import { render, staticRenderFns } from "./ProductTemplates.vue?vue&type=template&id=7814620f&lang=pug&"
import script from "./ProductTemplates.vue?vue&type=script&lang=js&"
export * from "./ProductTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports